import styled from "styled-components";

export const LogoWrapper = styled.div`
  min-height: 40px;
`;

export const CarrierLogo = styled.img`
  max-height: 40px;
`;
